import React from 'react';
import { Button } from '../../../../../../components/Common/UI/Button';
import { cn } from '../../../../../../utils/styles';
import { IAccount } from '../../../../Layout/Account/Data';

interface IAccountFeature {
  value: string;
  className: string;
  handleUpdate?: (value: string, key: keyof IAccount) => void;
  accountKey: keyof IAccount;
  active: boolean;
}

function AccountFeature({ value, className, handleUpdate, accountKey, active }: IAccountFeature) {
  return (
    <Button
      data-active={active}
      variant="ghost"
      className={cn(
        'uppercase py-[0] h-[20px] flex items-center px-[5px] border font-medium text-[12px] rounded-[2px]',
        className,
      )}
      onClick={() => {
        if (handleUpdate) handleUpdate(value, accountKey);
      }}
    >
      {value}
    </Button>
  );
}

AccountFeature.defaultProps = {
  handleUpdate: () => undefined,
};

export default AccountFeature;
